import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";

export default function InitialPasswordSetup() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [userToken, setUserToken] = useState(null);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { dispatch } = useAuthContext();

  const fetchData = async () => {
    try {
      const acctokenResponse = await axios.get(
        `${ApiConnectionString}/api/CreateUserToken/${token}`
      );
      setUserToken(acctokenResponse.data);
    } catch (e) {
      setError("There was a problem loading this link.");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!password || !confirmPassword) {
      setError("Please enter a password in both boxes.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    try {
      setSubmitting(true);
      const res = await axios.post(
        `${ApiConnectionString}/api/user/Confirm/${token}`,
        { password: password }
      );
      dispatch({ type: "LOGIN", payload: res.data });
      setSuccess("Password success. You can now continue.");
      setPassword("");
      setConfirmPassword("");
    } catch (e) {
      setError("There was a problem saving your password.");
    } finally {
      setSubmitting(false);
    }
  };

  if (!userToken) {
    return (
      <div className="container" style={{ marginBottom: "220px" }}>
        <h3>Loading</h3>
      </div>
    );
  }

  return (
    <div
      className="container"
      style={{ marginBottom: "220px", marginTop: "220px" }}
    >
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow-sm custom-card-light">
            <div className="card-body">
              <h3 className="card-title mb-3 brand-purple">
                Hello {userToken.name}, create your password
              </h3>

              <p className="mb-4 brand-dark-purple">
                Choose a password to finish setting up your account.
              </p>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              {success && (
                <div className="alert alert-success" role="alert">
                  {success}
                </div>
              )}

              {/* HIDE FORM WHEN SUCCESS IS TRUE */}
              {!success && (
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="new-password"
                      />
                      <button
                        type="button"
                        className="btn brand-purple-outline"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? "Hide" : "Show"}
                      </button>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Confirm password</label>
                    <div className="input-group">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        autoComplete="new-password"
                      />
                      <button
                        type="button"
                        className="btn brand-purple-outline"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? "Hide" : "Show"}
                      </button>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn brand-purple-inline w-100"
                    disabled={submitting}
                  >
                    {submitting ? "Saving..." : "Save password"}
                  </button>
                </form>
              )}

              {/* CONTINUE BUTTON AFTER SUCCESS */}
              {success && (
                <div className="mt-3">
                  <button
                    type="button"
                    className="btn brand-purple-inline w-100"
                    onClick={() => navigate("/")}
                  >
                    Continue
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
